/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Onboarding_Weekdays_Too_ManyInputs */

const en_us2_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pick at most ${i?.count}: the sessions per week you chose.`)
};

const pt_br2_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marque no máximo ${i?.count}: o número de treinos por semana que você escolheu.`)
};

const es_419_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marca como máximo ${i?.count}: los entrenamientos por semana que elegiste.`)
};

const pt_pt2_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Marca no máximo ${i?.count}: o número de treinos por semana que escolheste.`)
};

const fr_fr2_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Choisis-en ${i?.count} au maximum : le nombre de séances par semaine que tu as choisi.`)
};

const de_de2_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wähle höchstens ${i?.count}: die Zahl der Einheiten pro Woche, die du gewählt hast.`)
};

const it_it2_onboarding_weekdays_too_many = /** @type {(inputs: Onboarding_Weekdays_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scegline al massimo ${i?.count}: gli allenamenti a settimana che hai indicato.`)
};

/**
* | output |
* | --- |
* | "Pick at most {count}: the sessions per week you chose." |
*
* @param {Onboarding_Weekdays_Too_ManyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_weekdays_too_many = /** @type {((inputs: Onboarding_Weekdays_Too_ManyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Weekdays_Too_ManyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_weekdays_too_many(inputs)
	if (locale === "es-419") return es_419_onboarding_weekdays_too_many(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_weekdays_too_many(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_weekdays_too_many(inputs)
	if (locale === "de-DE") return de_de2_onboarding_weekdays_too_many(inputs)
	if (locale === "it-IT") return it_it2_onboarding_weekdays_too_many(inputs)
	return en_us2_onboarding_weekdays_too_many(inputs)
});
export { onboarding_weekdays_too_many as "onboarding.weekdays_too_many" }